import React from 'react';
import { ModalHeader, ModalBody } from 'reactstrap';

function ModalLoadError({ onClose = () => {} }) {
  return (
    <>
      <ModalHeader toggle={onClose}>'Choose an assessment'</ModalHeader>

      <ModalBody>
        <p className="text-danger">
          Unable to load available assessment questions.
        </p>
      </ModalBody>
    </>
  );
}

export default ModalLoadError;
